module.exports = __webpack_public_path__ + "img/premium.5e746508.png";